<div class="lot-specs">
  <article class="lot-specs__detail-card">
    <header class="lot-specs__detail-header">
      <i class="iconsax lot-specs__detail-icon" icon-name="tag-2"></i>
      <h3 class="lot-specs__detail-title">
        {{ 'auctions.detailedSpecifications' | translate }}
      </h3>
    </header>
    <p class="lot-specs__detail-text">
      {{
        (auction()?.description | translateData) ||
          (auction()?.product?.description | translateData) ||
          ('auctions.noSpecDescription' | translate)
      }}
    </p>
  </article>

  <div class="lot-specs__grid">
    <article class="lot-specs__grid-card">
      <p class="lot-specs__grid-label">{{ 'auctions.bulkQuantity' | translate }}</p>
      <p class="lot-specs__grid-value">
        @if (auction()?.amount?.value) {
          {{ auction()?.amount?.value }}
          @if (auction()?.amount?.unit) {
            {{ 'enums.measurements.' + auction()?.amount?.unit | translate }}
          }
        } @else {
          -
        }
      </p>
    </article>

    <article class="lot-specs__grid-card">
      <p class="lot-specs__grid-label">{{ 'auctions.shipmentTerms' | translate }}</p>
      <p class="lot-specs__grid-value">{{ shipmentTermsLabel() }}</p>
    </article>

    <article class="lot-specs__grid-card">
      <p class="lot-specs__grid-label">{{ 'auctions.deliveryCity' | translate }}</p>
      <p class="lot-specs__grid-value lot-specs__grid-value--location">
        <i class="iconsax" icon-name="location"></i>
        {{ deliveryCityLabel() }}
      </p>
    </article>

    <article class="lot-specs__grid-card">
      <p class="lot-specs__grid-label">{{ 'auctions.paymentTerms' | translate }}</p>
      <p class="lot-specs__grid-value lot-specs__grid-value--payment">
        {{ paymentTermsLabel() }}
      </p>
    </article>
  </div>
</div>
